import { render } from "./VehicleInfo.vue?vue&type=template&id=10d8c1d7&scoped=true"
import script from "./VehicleInfo.vue?vue&type=script&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&lang=js"

import "./VehicleInfo.vue?vue&type=style&index=0&id=10d8c1d7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d8c1d7"]])

export default __exports__